import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import Swiper from './components/Swiper.js'
import Splash from './components/Splash'
import Curtains from './components/Curtains'
import Slide from './components/Slide'
import SignUp from './components/SignUp'
import Logo from './components/Logo'
import RotateNotification from '../shared/components/RotateNotification'
import { runSequence, stopSequence } from 'utils/sequence'
import { getImageUrlsFromSettings, preloadImages, scrollFix } from 'utils/templatesUtils'
import { customCSSObjectToString } from 'utils/serializerCSS'
import scenes from './scenes'
import { appLoaded } from '../shared/analytics'

import './InstantApp.scss'


export default class InstantApp extends Component {

  state = {
    scene: 1,
  }

  switchScene (newScene) {
    this.updateState({ scene: newScene })
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.location) {
      this.switchScene(scenes.indexOf(nextProps.location.scene))
    }

    if (!this.props.showcaseMode && nextProps.showcaseMode) {
      this.startAnimations()
    }
  }

  componentDidMount () {
    if (!this.props.editMode && !this.props.showcaseMode) {
      scrollFix()
    }

    preloadImages(getImageUrlsFromSettings(this.props.settings)) // Preload all images from settings

    if (this.prodMode()) appLoaded()
    if (!this.props.editMode) this.startAnimations()
  }

  startAnimations () {
    const { scene } = this.state
    const s1 = { fn: () => this.switchScene(1), delay: 1500 }
    const s2 = { fn: () => this.switchScene(2), delay: 3000 }
    const s3 = { fn: () => this.switchScene(3), delay: 3000 }
    if (scene === 0) {
      this.sequenceId = runSequence([s1, s2, s3])
    } else if (scene === 1) {
      this.sequenceId = runSequence([s2, s3])
    } else if (scene === 2) {
      this.sequenceId = runSequence([s3])
    }
  }

  componentWillUnmount () {
    stopSequence(this.sequenceId)
  }

  prodMode = () => !this.props.editMode && !this.props.showcaseMode

  updateState (state) {
    // console.log('updateState', state)
    if (state.scene !== this.state.scene) {
      this.setState(state, () => {
        const loc = {
          scene: scenes[this.state.scene]
        }
        if (this.prodMode()) window.ga('send', 'screenview', {screenName: JSON.stringify(loc)})
        this.props.onChange(loc)
      })
    }
  }

  onLoadedStylesheet = () => {
    this.forceUpdate()
  }

  onTransitionEnd = (swiper) => {
    this.updateState({scene: swiper.activeIndex + 3})
  }

  onLinkMounted = linkRef => {
    if (linkRef) {
      linkRef.addEventListener('load', this.onLoadedStylesheet)
    }
  }

  render () {
    const { settings, editMode, showcaseMode } = this.props
    const { scene } = this.state
    const logo = settings[`scene${scene}`].logo || settings.scene1.logo
    return (
      <div className='fi_root'>
        <link
          key={settings.customStylesRawDownloadUrl}
          rel={'stylesheet'}
          ref={this.onLinkMounted}
          href={settings.customStylesRawDownloadUrl}
        />
        <link
          key={settings.customStylesDownloadUrl}
          rel={'stylesheet'}
          ref={this.onLinkMounted}
          href={settings.customStylesDownloadUrl}
        />
        <style id='customStyles'>{customCSSObjectToString(settings.customStyles)}</style>
        {!editMode && !showcaseMode && <RotateNotification />}
        {/* Top-left logo */}
        {(scene > 1) && <Logo logo={logo} scene={scene} />}
        {/* Splash scene */}
        <Splash {...settings.scene1} isVisible={scene === 1} />
        {/* Curtains scene */}
        <Curtains {...settings.scene2} isVisible={scene === 2} />
        {/* Swiper scenes - slides and sign up scene */}
        <CSSTransitionGroup
          transitionName='fi_swiper'
          transitionEnterTimeout={600}
          transitionLeaveTimeout={1000}
        >
          {(scene > 2) &&
            <Swiper
              id='swiper'
              slide={this.state.scene - 3}
              onTransitionEnd={this.onTransitionEnd}
            >
              <Slide {...settings.scene3} slideNum={3} key={1} />
              <Slide {...settings.scene4} slideNum={4} key={2} />
              <Slide {...settings.scene5} slideNum={5} key={3} />
              <Slide {...settings.scene6} slideNum={6} key={4} />
              <Slide {...settings.scene7} slideNum={7} key={5} />
              <Slide {...settings.scene8} slideNum={8} key={6} />
              <Slide {...settings.scene9} slideNum={9} key={7} />
              <SignUp {...settings.scene10} key={8} />
            </Swiper>
          }
        </CSSTransitionGroup>
      </div>
    )
  }

  static defaultProps = {
    location: null,
    onChange: () => null,
  }

  static propTypes = {
    settings: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    editMode: PropTypes.bool,
    showcaseMode: PropTypes.bool,
    location: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  }
}



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/InstantApp.js